import { Card } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Send } from "lucide-react";
import { toast } from "sonner";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";

interface CustomerDebtorsProps {
  data: any[];
}

export function CustomerDebtors({ data }: CustomerDebtorsProps) {
  const debtors = data
    .filter((customer) =>
      customer.transactions?.some(
        (t: any) =>
          t.payment_status === "pendente" || t.payment_status === "atrasado"
      )
    )
    .map((customer) => {
      const totalDebt = customer.transactions
        ?.filter(
          (t: any) =>
            (t.payment_status === "pendente" ||
              t.payment_status === "atrasado") &&
            t.type === "entrada"
        )
        .reduce((sum: number, t: any) => sum + Number(t.amount), 0);

      return {
        ...customer,
        totalDebt,
      };
    })
    .sort((a, b) => b.totalDebt - a.totalDebt);

  const handleSendReminder = (customerId: string) => {
    // TODO: Implement WhatsApp integration
    toast.info("Integração com WhatsApp em desenvolvimento");
  };

  const chartData = debtors.slice(0, 5).map((debtor) => ({
    name: debtor.name,
    valor: debtor.totalDebt,
  }));

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 text-red-600">
        <AlertTriangle className="h-5 w-5" />
        <h3 className="text-lg font-semibold">Top 5 Maiores Devedores</h3>
      </div>

      <div className="rounded-lg border bg-card p-4">
        <BarChart width={600} height={300} data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="valor" fill="#E60026" />
        </BarChart>
      </div>

      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Cliente</TableHead>
            <TableHead>Telefone</TableHead>
            <TableHead>Valor em Atraso</TableHead>
            <TableHead>Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {debtors.map((debtor) => (
            <TableRow key={debtor.id}>
              <TableCell>{debtor.name}</TableCell>
              <TableCell>{debtor.phone}</TableCell>
              <TableCell className="text-red-600">
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(debtor.totalDebt)}
              </TableCell>
              <TableCell>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => handleSendReminder(debtor.id)}
                >
                  <Send className="mr-2 h-4 w-4" />
                  Enviar Lembrete
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}